@for (item of shown(); track item.target) {
  @switch (item.target.label) {
    @case ('merge') {
      <div
        data-testid="timeline-edit-merge"
        class="edit-merge"
        [class.is-hot]="item.hot"
        [style.left.px]="item.left"
        [style.width.px]="item.width"></div>
      @if (item.hot) {
        <span class="edit-tag" [style.left.px]="item.left + item.width / 2">
          {{ 'features.plan.edit.targets.merge' | translate }}
        </span>
      }
    }
    @case ('end') {
      <div
        data-testid="timeline-edit-end"
        class="edit-end"
        [class.is-hot]="item.hot"
        [style.left.px]="item.x">
        {{ 'features.plan.edit.targets.end' | translate }}
      </div>
    }
    @default {
      <div
        data-testid="timeline-edit-gap"
        class="edit-gap"
        [class.is-hot]="item.hot"
        [style.left.px]="item.x"></div>
      @if (item.hot && item.target.stop; as stop) {
        <span class="edit-tag" [style.left.px]="item.x">
          {{ 'features.plan.edit.targets.before' | translate }}
          <span class="font-mono font-medium"
            >{{ stop.name }} {{ stop.start | date: 'HH:mm' }}</span
          >
        </span>
      }
    }
  }
}

@if (carried(); as carried) {
  <div class="edit-carried" aria-hidden="true">
    <i
      [class]="
        carried.kind === 'job'
          ? ICONS.package
          : carried.kind === 'tour'
            ? ICONS.stack
            : ICONS.mapPinSimple
      "
      class="text-xs"></i>
    <span class="font-mono">{{ carried.name }}</span>
    @if (carried.kind === 'job') {
      <span class="edit-carried-from"
        >{{ carried.site }}{{ carried.quantity ? ' ' + carried.quantity : '' }}</span
      >
    }
  </div>
}
